import { render, staticRenderFns } from "./AclPerfis.vue?vue&type=template&id=7771c7b7"
import script from "./AclPerfis.vue?vue&type=script&lang=js"
export * from "./AclPerfis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports